/* eslint-disable max-lines */
import { Card } from "../../../../../_webui/layout/components/Card"
import { Table } from "../../../../../_webui/layout/components/Table"
import { FC } from "react"
import { useTravelersList } from "./modules/useList"
import { Layout } from "../../../../../_webui/layout/components/Layout"
import { Translate } from "../../../../../constant/Translate"
import { TotalRecords } from "../../../../../_webui/layout/components/Typography/TotalRecords"
import { TravelersButtonGroup } from "../../components/list/ButtonGroup"
import { TravelerFormSearch } from "../../components/list/FormSearch"
import { TravelerHeadingButton } from "../../components/list/HeadingButton"
import { ModalConfirm } from "../../../../../_webui/layout/components/Modal/Confirm"

const { MESSAGE_C0037, MESSAGE_C0038, TEXT_T021 } = Translate

export const TravelersList: FC = () => {
  const {
    allCountries,
    breadcrumbItems,
    cities,
    columns,
    countryCode,
    dataSource,
    departments,
    dispatchType,
    form,
    goToSchedulesAdd,
    goToSchedulesAddDraft,
    goToTravelersDelete,
    goToTravelersDetail,
    goToTravelersEditDraft,
    handleExportFile,
    isDisabledBtnDelete,
    isDisabledBtnRefer,
    isHiddenBtnDelete,
    isHiddenBtnExportFile,
    isHiddenBtnRefer,
    isHiddenBtnRegister,
    isHiddenBtnRequestDelete,
    isHiddenBtnScheduleDraft,
    isHiddenBtnTravelerDraft,
    isLoading,
    isLoadingLayout,
    isOpen,
    isOtherCity,
    isOverseasResident,
    isPathnameTravelers,
    isPathnameTravelersUser,
    isPathnameTravelersUserSearch,
    onCancel,
    onChange,
    onChangeTable,
    onChangeWorkPlaceCity,
    onChangeWorkPlaceCountry,
    onChangeWorkPlaceLocation,
    onClickReset,
    onFinish,
    onOpen,
    perItem,
    rowSelection,
  } = useTravelersList()

  return (
    <Layout
      breadcrumbItems={breadcrumbItems}
      isLoadingLayout={isLoadingLayout}
      title={TEXT_T021}
    >
      <Card
        childrenRight={
          <TravelerHeadingButton
            goToSchedulesAddDraft={goToSchedulesAddDraft}
            goToTravelersEditDraft={goToTravelersEditDraft}
            isHiddenBtnScheduleDraft={isHiddenBtnScheduleDraft}
            isHiddenBtnTravelerDraft={isHiddenBtnTravelerDraft}
            isPathnameTravelers={isPathnameTravelers}
            isPathnameTravelersUser={isPathnameTravelersUser}
          />
        }
        heading={TEXT_T021}
        isLoading={isLoading}
      >
        <TravelerFormSearch
          allCountries={allCountries}
          cities={cities}
          countryCode={countryCode}
          dispatchType={dispatchType}
          departments={departments}
          form={form}
          isOtherCity={isOtherCity}
          isOverseasResident={isOverseasResident}
          onChangeWorkPlaceCity={onChangeWorkPlaceCity}
          onChangeWorkPlaceCountry={onChangeWorkPlaceCountry}
          onChangeWorkPlaceLocation={onChangeWorkPlaceLocation}
          onClickReset={onClickReset}
          onFinish={onFinish}
        />
        <TotalRecords
          titleLeft={isPathnameTravelersUserSearch && TEXT_T021}
          perItem={perItem}
          total={dataSource?.length}
        />
        <Table
          columns={columns}
          dataSource={dataSource}
          onChange={onChange}
          onChangeTable={onChangeTable}
          rowKey="travelerId"
          rowSelection={rowSelection}
        />
        <TravelersButtonGroup
          goToSchedulesAdd={goToSchedulesAdd}
          goToTravelersDelete={goToTravelersDelete}
          goToTravelersDetail={goToTravelersDetail}
          onOpen={onOpen}
          isDisabledBtnDelete={isDisabledBtnDelete}
          isDisabledBtnRefer={isDisabledBtnRefer}
          isHiddenBtnDelete={isHiddenBtnDelete}
          isHiddenBtnExportFile={isHiddenBtnExportFile}
          isHiddenBtnRefer={isHiddenBtnRefer}
          isHiddenBtnRegister={isHiddenBtnRegister}
          isHiddenBtnRequestDelete={isHiddenBtnRequestDelete}
        />

        <ModalConfirm
          isOpen={isOpen}
          onCancel={onCancel}
          onOk={handleExportFile}
        >
          {rowSelection?.selectedRowKeys?.length
            ? MESSAGE_C0037
            : MESSAGE_C0038}
        </ModalConfirm>
      </Card>
    </Layout>
  )
}
